import getScenarioStore from '../selectors/getScenarioStore';
import KeyboardCharCodes from 'owa-hotkeys/lib/utils/keyboardCharCodes';
import { mutator } from 'satcheljs';
import { onKeyDownSearchInput } from '../actions/internalActions';

mutator(onKeyDownSearchInput, actionMessage => {
    const { evtKeyCode, scenarioId } = actionMessage;

    getScenarioStore(scenarioId).isLastKeyPressedDeletion =
        evtKeyCode === KeyboardCharCodes.Backspace || evtKeyCode === KeyboardCharCodes.Delete;
});
